import React from "react";
import { Card, Row, Col, Alert } from "antd";
import dayjs from "dayjs";
import { MemberProfile } from "../../../../model/members/MemberProfile";
import { statusMeta, daysLeft, EXPIRY_WARN_DAYS } from "./validity";
import ValidityMeter from "./ValidityMeter";

interface StatusValidityCardProps {
    member: MemberProfile;
}

// Membership status + validity, with a 4px left status stripe. An Alert
// summarises state, then valid-from / valid-to as a 2-col key/value, then the
// validity meter.
const StatusValidityCard: React.FC<StatusValidityCardProps> = ({ member }) => {
    const sm = statusMeta(member);
    const left = daysLeft(member);
    const danger = left <= EXPIRY_WARN_DAYS;
    const fmt = (d: Date) => (d ? dayjs(d).format("DD MMM YYYY") : "—");

    const banner =
        sm.tone === "err"
            ? { type: "error" as const, msg: sm.text === "Expired" ? "Membership has expired" : "Membership is not active" }
            : danger
              ? { type: "warning" as const, msg: `Membership expires in ${left} days` }
              // Membership-level only: payment problems (arrears, failed membership
              // payments) are raised in Needs attention, which this card can't see.
              : { type: "success" as const, msg: "Membership active" };

    return (
        <Card title="Membership" size="small" className={`ft-stripe ${sm.tone}`} styles={{ body: { padding: 16 } }}>
            <Alert type={banner.type} message={banner.msg} showIcon style={{ marginBottom: 14, borderRadius: 8 }} />
            <Row gutter={[12, 12]}>
                <Col span={12}>
                    <div className="ft-kv">
                        <span className="k">Valid from</span>
                        <span className="v">{fmt(member.validFrom)}</span>
                    </div>
                </Col>
                <Col span={12}>
                    <div className="ft-kv">
                        <span className="k">Valid to</span>
                        <span className="v">{fmt(member.validTo)}</span>
                    </div>
                </Col>
            </Row>
            <ValidityMeter member={member} showDates={false} style={{ marginTop: 14 }} />
        </Card>
    );
};

export default StatusValidityCard;
